import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { updateLocalStorage } from "../../../../AppDrawerNav";
import {
  childNodeNavText,
  goldenReponseNodeStyles,
  goldenResponsesButtonStyles,
  nodeStyles,
  topNavNode,
} from "../GeneralNodeStyles";
import { dialogStyles } from "../../../../../../Constants/dialogStyles";
import {
  inputStyles,
  radioGroupStyles,
} from "../../../../../../Constants/inputStyles";
import theme, { createLLMTypography } from "../../../../../../Constants/theme";
import { goldenResponsesSectionStyles } from "./GoldenResponsesStyles";
import {
  deleteIconStyles,
  iconButtonActive,
  primaryButtonStyles,
  secondaryButtonStyles,
  textButtonStyles,
} from "../../../../../../Constants/buttonStyles";
import { Circle, FolderOutlined } from "@mui/icons-material";

function GoldenResponseNode({ data }) {
  const organization = useSelector((state) => state.organization);
  const [golden_response, set_golden_response] = useState({
    question: "",
    answer: "",
  }); // state to store textfield text
  const [golden_response_validation, set_golden_response_validation] =
    useState(false); // state to show validation msg
  const [open_golden_response, set_open_golden_response] = useState(false); // open view all dilog box
  const [selectedOption, setSelectedOption] = useState("userQna"); //  choose type of gqna
  const [generatedQnaCount, setGeneratedQnaCount] = useState(5);
  const [openDialog, setOpenDialog] = useState(false); // opens warning dialog
  const [pendingOption, setPendingOption] = useState(null); // which option user wants to change to
  const [golden_responses_list, setGolden_responses_list] = useState([]);

  // onchange function for golden responses choices
  const handleOptionChange = (event) => {
    const newValue = event.target.value;

    // Check if golden responses array is not empty
    if (golden_responses_list?.length > 0) {
      setPendingOption(newValue); // Save the new option
      setOpenDialog(true); // Open confirmation dialog
    } else {
      updateOption(newValue); // Update the option if no golden responses
    }
  };
  const updateOption = (newValue) => {
    setSelectedOption(newValue);
    localStorage.setItem("golden_responses_option", JSON.stringify(newValue));
    // setData((prevData) => ({
    //   ...prevData,
    //   golden_responses_option: newValue,
    // }));
    data.setBotData((prevData) => ({
      ...prevData,
      golden_responses_option: newValue,
    }));
  };

  // on close for confirming user wants to switch options
  const handleDialogClose = (confirm) => {
    setOpenDialog(false);

    if (confirm) {
      // User confirmed to change the option
      updateOption(pendingOption);

      // Clear golden responses
      // setData((prevData) => ({ ...prevData, golden_responses: [] }));
      data.setBotData((prevData) => ({ ...prevData, golden_responses: [] }));
      setGolden_responses_list([]);
      localStorage.removeItem("golden_responses");
    } else {
      // User canceled, reset pendingOption
      setPendingOption(null);
    }
  };

  // gets data from local storage/botdata if exists and sets usestates
  useEffect(() => {
    // read & parse once
    const rawGolden = localStorage.getItem("golden_responses");
    const parsedGolden = rawGolden ? JSON.parse(rawGolden) : undefined;

    const rawOption = localStorage.getItem("golden_responses_option");
    const parsedOption = rawOption
      ? JSON.parse(rawOption)
      : data.botData.golden_responses_option || "userQna";

    const rawCount = localStorage.getItem("num_of_qa_pairs");
    const initialCount = rawCount
      ? JSON.parse(rawCount)
      : data.botData.num_of_qa_pairs || 5;

    // update local state in one go
    data.setBotData((prev) => ({
      ...prev,
      ...(parsedGolden != null && { golden_responses: parsedGolden }),
      golden_responses_option: parsedOption,
      num_of_qa_pairs: initialCount,
    }));

    setSelectedOption(parsedOption);
    setGeneratedQnaCount(initialCount);
    if (parsedGolden != null) {
      setGolden_responses_list(parsedGolden);
    }
  }, []);

  // opens info sidebar
  const handleOpenSideBar = (infotype, event) => {
    event.stopPropagation();
    updateLocalStorage("open_sidebar", "true");
    updateLocalStorage("type", infotype);
  };

  // delete golden qna
  const handleDeleteResponse = (index) => {
    let responses = golden_responses_list;
    responses.splice(index, 1);
    data.setBotData((prevData) => ({
      ...prevData,
      golden_responses: [...responses],
    }));
    setGolden_responses_list([...responses]);
    localStorage.setItem("golden_responses", JSON.stringify([...responses]));
  };

  // onchange function for question and answer textfields
  const handleChange_question = (e) => {
    set_golden_response_validation(false);
    set_golden_response({ ...golden_response, question: e.target.value });
  };
  const handleChange_answer = (e) => {
    set_golden_response_validation(false);
    set_golden_response({ ...golden_response, answer: e.target.value });
  };

  // upload qna on csv function
  function handleUploadCsv(event) {
    const file = event.target.files[0]; // Get the uploaded file
    if (!file) return; // Handle no file selected

    const g_r = JSON.parse(localStorage.getItem("golden_responses")) || [];

    // Check if the file is a valid CSV file
    if (file.type !== "text/csv") {
      data.showSnackbar("Please select a valid CSV file.", "error");
      event.target.value = ""; // Reset the file input

      return;
    }

    Papa.parse(file, {
      header: true, // Parse the header row
      complete: (results) => {
        const validQuestionKeys = ["question", "questions"];
        const validAnswerKeys = ["answer", "answers"];

        // Get the headers from the first row
        const headers = Object.keys(results.data[0] || {});

        // Find a matching question header (case-insensitive)
        const questionHeader = headers.find((h) =>
          validQuestionKeys.includes(h.trim().toLowerCase())
        );
        // Find a matching answer header
        const answerHeader = headers.find((h) =>
          validAnswerKeys.includes(h.trim().toLowerCase())
        );

        if (!questionHeader || !answerHeader) {
          data.showSnackbar(
            `The CSV file must contain one of ${validQuestionKeys
              .map((k) => `"${k}"`)
              .join(" or ")} and one of ${validAnswerKeys
              .map((k) => `"${k}"`)
              .join(" or ")} columns.`,
            "error"
          );
          event.target.value = ""; // Reset the file input
          return;
        }
        // Filter valid rows with non-empty question and answer
        const qnaPairs = results.data
          .filter(
            (row) =>
              row[questionHeader]?.toString().trim() &&
              row[answerHeader]?.toString().trim()
          )
          .map((row) => ({
            question: row[questionHeader].toString().trim(),
            answer: row[answerHeader].toString().trim(),
          }));
        // Deduplicate golden responses
        const existingGoldenResponses =
          data.botData?.golden_responses || golden_responses_list || [];
        const mergedResponses = [
          ...existingGoldenResponses,
          ...qnaPairs,
        ].reduce((acc, curr) => {
          if (!acc.some((item) => item.question === curr.question)) {
            acc.push(curr);
          }
          return acc;
        }, []);

        // Check for limits and permissions
        const totalGoldenResponses = mergedResponses.length;
        const isStarterSubscription =
          organization?.organization?.subscription === "starter";
        const hasOpenAIKey =
          organization?.organization?.llm_keys?.openai_key?.key;
        const hasPineconeKey = organization?.organization?.pinecone_key?.key;

        if (
          totalGoldenResponses > 5 &&
          isStarterSubscription &&
          (!hasOpenAIKey || !hasPineconeKey)
        ) {
          data.showSnackbar(
            "You can only add 5 Golden Responses. For more, please subscribe to Queryloop Pro or add your own OpenAI and Pinecone keys!",
            "error"
          );
          event.target.value = ""; // Reset the file input

          return;
        }

        // Update local storage, botData, and state
        localStorage.setItem(
          "golden_responses",
          JSON.stringify(mergedResponses)
        );

        // setData((prevData) => ({
        //   ...prevData,
        //   golden_responses: mergedResponses,
        // }));

        data.setBotData((prevData) => ({
          ...prevData,
          golden_responses: mergedResponses,
        }));
        setGolden_responses_list(mergedResponses);

        data.showSnackbar("Golden Responses uploaded successfully.", "success");
        event.target.value = "";
      },
      error: (error) => {
        console.error("Error parsing CSV:", error);
        data.showSnackbar(
          "An error occurred while parsing the CSV file.",
          "error"
        );
        event.target.value = "";
      },
    });
  }

  // onchange and onblur functions for generateqna count
  const handleCountChange = (e) => {
    const val = e.target.value;
    if (val === "") {
      setGeneratedQnaCount("");
      return;
    }
    const raw = Math.floor(Number(val));
    if (isNaN(raw)) return;
    const clamped = Math.min(50, Math.max(1, raw));
    setGeneratedQnaCount(clamped);
    // persist
    localStorage.setItem("num_of_qa_pairs", JSON.stringify(clamped));
    // setData((prev) => ({ ...prev, num_of_qa_pairs: clamped }));
    data.setBotData((prev) => ({ ...prev, num_of_qa_pairs: clamped }));
  };
  const handleCountBlur = () => {
    const num = Math.floor(Number(generatedQnaCount));
    let final = num;
    if (isNaN(num) || num < 1) final = 5;
    if (num > 50) final = 50;
    setGeneratedQnaCount(final);
    localStorage.setItem("num_of_qa_pairs", JSON.stringify(final));
    // setData((prev) => ({ ...prev, num_of_qa_pairs: final }));
    data.setBotData((prev) => ({ ...prev, num_of_qa_pairs: final }));
  };

  // onclick for add response button
  const handleAddResponse = () => {
    const { question, answer } = golden_response;
    const isUserOnly = selectedOption === "userOnlyQ";

    // 1) Validate inputs
    if (!question.trim() || (!isUserOnly && !answer.trim())) {
      set_golden_response_validation(true);
      return;
    }

    // 2) Build the new item
    const newResponse = { question, answer: isUserOnly ? "" : answer };

    // 3) Load existing and compute limits
    const existing = JSON.parse(
      localStorage.getItem("golden_responses") || "[]"
    );
    const currentLen = golden_responses_list?.length || 0;
    const isStarter = organization?.organization?.subscription === "starter";
    const hasKeys =
      Boolean(organization?.organization?.llm_keys?.openai_key?.key) ||
      Boolean(organization?.organization?.pinecone_key?.key);

    // 4) Check if user may add
    const canAdd = !isStarter || currentLen < 5 || hasKeys;
    if (!canAdd) {
      data.showSnackbar(
        `You can only add 5 Golden ${
          isUserOnly ? "Questions" : "Responses"
        }. ` +
          `For more, please subscribe to Queryloop Pro or add your own OpenAI & Pinecone keys!`,
        "error"
      );
      return;
    }

    // 5) Append everywhere
    const updated = [...existing, newResponse];
    // setData((prev) => ({ ...prev, golden_responses: updated }));
    data.setBotData((prev) => ({ ...prev, golden_responses: updated }));
    setGolden_responses_list(updated);
    localStorage.setItem("golden_responses", JSON.stringify(updated));

    // 6) Clear input
    set_golden_response({ question: "", answer: "" });
  };

  return (
    <Box
      sx={{ ...nodeStyles, ...goldenReponseNodeStyles }}
      data-tour="step-three"
    >
      <Box sx={{ ...topNavNode }}>
        <Typography sx={childNodeNavText}>Golden Responses</Typography>
        <div>
          <InfoOutlined
            onClick={(event) => handleOpenSideBar("golden_responses", event)}
          />
        </div>
      </Box>

      <Box sx={goldenResponsesButtonStyles}>
        <Box paddingX={1}>
          <Typography
            sx={{
              fontSize: createLLMTypography.fontSizes.sectionTitle,
              mt: 1,
            }}
          >
            Please select your QnA option
          </Typography>
          <FormControl fullWidth>
            <RadioGroup
              value={selectedOption}
              onChange={handleOptionChange}
              sx={{ ...radioGroupStyles.container, ml: 1 }}
            >
              <FormControlLabel
                value="userQna"
                control={
                  <Radio
                    size="small"
                    sx={radioGroupStyles.radio}
                    checkedIcon={
                      <Circle
                        fontSize="small"
                        sx={{ color: theme.main.primaryBlue }}
                      />
                    }
                  />
                }
                sx={{ ...radioGroupStyles.formControlLabel, my: 0 }}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: createLLMTypography.fontSizes.sectionText1,
                      }}
                    >
                      I have golden QnA
                    </Typography>
                    <Tooltip
                      title="AI retrieved documents and generated responses will be measured in terms in accuracy and correctness, respectively, with reference to the provided golden responses."
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        sx={{ color: theme.inputs.iconColor }}
                      />
                    </Tooltip>
                  </Box>
                }
              />

              <FormControlLabel
                value="userOnlyQ"
                control={
                  <Radio
                    size="small"
                    sx={radioGroupStyles.radio}
                    checkedIcon={
                      <Circle
                        fontSize="small"
                        sx={{ color: theme.main.primaryBlue }}
                      />
                    }
                  />
                }
                sx={{ ...radioGroupStyles.formControlLabel, my: 0 }}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: createLLMTypography.fontSizes.sectionText1,
                      }}
                    >
                      I have sample questions only
                    </Typography>
                    <Tooltip
                      title="AI retrieved documents and generated responses will be measured in terms in relevance and completeness. However, accuracy and correctness will not be measured."
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        sx={{ color: theme.inputs.iconColor }}
                      />
                    </Tooltip>
                  </Box>
                }
              />
              <FormControlLabel
                value="generateQna"
                control={
                  <Radio
                    size="small"
                    sx={radioGroupStyles.radio}
                    checkedIcon={
                      <Circle
                        fontSize="small"
                        sx={{ color: theme.main.primaryBlue }}
                      />
                    }
                  />
                }
                sx={{ ...radioGroupStyles.formControlLabel, my: 0 }}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",

                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: createLLMTypography.fontSizes.sectionText1,
                      }}
                    >
                      Generate
                    </Typography>
                    <Tooltip
                      title={
                        organization?.organization?.subscription === "starter"
                          ? "Pro Feature: Unlock Generated QnA counts by upgrading to Pro subscription."
                          : "How many QnAs should we generate for you? (1-50)"
                      }
                      arrow
                    >
                      <TextField
                        type="number"
                        size="small"
                        value={generatedQnaCount}
                        onChange={handleCountChange}
                        onBlur={handleCountBlur}
                        disabled={
                          organization?.organization?.subscription === "starter"
                        }
                        inputProps={{
                          min: 1,
                          max: 50,
                          step: 1,
                          sx: {
                            "& input": {
                              MozAppearance: "textfield",
                              padding: 0,
                            },
                          },
                        }}
                        sx={{
                          ...inputStyles.textField,
                          fontSize: createLLMTypography.fontSizes.sectionText1,
                          borderColor: theme.inputs.borderColor,
                          my: 0,
                          mx: 0.5,
                          // make wrapper transparent
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "transparent",
                            padding: 0,
                            // default border
                            "& fieldset": {
                              borderColor: theme.inputs.textColor,
                              px: "2px",
                            },
                            // hover border
                            "&:hover fieldset": {
                              borderColor: theme.inputs.textColor,
                            },
                            // focused border
                            "&.Mui-focused fieldset": {
                              borderColor: theme.inputs.textColor,
                            },
                          },

                          // target the inner <input> and force your padding/text‐align
                          "& .MuiOutlinedInput-input": {
                            textAlign: "center",
                            padding: "2px", // your desired padding
                          },

                          // hide native up/down controls
                          "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                          "& input[type=number]": {
                            MozAppearance: "textfield",
                          },
                        }}
                      />
                    </Tooltip>
                    <Typography
                      sx={{
                        fontSize: createLLMTypography.fontSizes.sectionText1,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Golden QnA for me
                    </Typography>
                    <Tooltip
                      title="To create the best possible golden QnAs for your use case, we recommend adding a retrieval module with some data. This will help generate high-quality QnAs tailored to your requirements."
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        sx={{ color: theme.inputs.iconColor, ml: 1 }}
                      />
                    </Tooltip>
                  </Box>
                }
              />
            </RadioGroup>
          </FormControl>
        </Box>
        <Box paddingX={1}>
          {" "}
          {selectedOption !== "generateQna" && (
            <Button
              fullWidth
              sx={{
                ...primaryButtonStyles,
                borderRadius: theme.borderRadius.sm,
                fontSize: theme.typography.fontSize.md,
                fontWeight: theme.typography.fontWeight.bold,
                my: 1,
              }}
              onClick={() => set_open_golden_response(true)}
            >
              Add Golden{" "}
              {selectedOption === "userOnlyQ" ? "Questions" : "Responses"}
            </Button>
          )}
          {selectedOption !== "generateQna" && (
            <Typography sx={inputStyles.informationText}>
              *{golden_responses_list.length} Golden{" "}
              {selectedOption === "userOnlyQ" ? "Questions" : "Responses"}{" "}
              Added.{" "}
              <span
                style={{
                  ...secondaryButtonStyles,
                  padding: "5px 7px",
                  mb: 1,
                }}
                onClick={() => set_open_golden_response(true)}
              >
                View all
              </span>
            </Typography>
          )}
        </Box>
      </Box>
      <Dialog
        fullWidth
        open={open_golden_response}
        onClose={() => set_open_golden_response(false)}
        PaperProps={{ sx: { ...dialogStyles.dialogRoot } }}
      >
        <DialogContent sx={dialogStyles.dialogContent}>
          <Paper sx={goldenResponsesSectionStyles}>
            {selectedOption === "userQna" ? (
              <DialogContentText sx={dialogStyles.dialogContentText}>
                Input your desired QnA against which the chatbot responses will
                be compared.
              </DialogContentText>
            ) : (
              <DialogContentText sx={dialogStyles.dialogContentText}>
                Upload your desired questions, and the Queryloop will generate
                the corresponding answers for comparison.
              </DialogContentText>
            )}
            {selectedOption === "userQna" ? (
              <Typography
                variant="caption"
                sx={{ color: theme.textColors.dark.primary }}
              >
                Golden responses are essential for evaluation as they serve as
                benchmark answers against which chatbot-generated responses are
                measured to assess their performance and accuracy.
              </Typography>
            ) : (
              <Typography
                variant="caption"
                sx={{ color: theme.textColors.dark.primary }}
              >
                Uploaded questions are essential for evaluation as they serve as
                the basis for generating benchmark answers. These answers are
                compared with chatbot-generated responses to assess performance
                and accuracy.
              </Typography>
            )}
          </Paper>
          <Paper sx={goldenResponsesSectionStyles}>
            <Typography
              variant="caption"
              sx={{ color: theme.textColors.dark.primary, mt: 1 }}
            >
              Question
            </Typography>
            <TextField
              value={golden_response.question}
              maxRows={4}
              multiline
              fullWidth
              placeholder="Enter Question here..."
              onChange={(event) => handleChange_question(event)}
              sx={inputStyles.textField}
            />
            {selectedOption !== "userOnlyQ" && (
              <Typography
                variant="caption"
                sx={{ color: theme.textColors.dark.primary, mt: 1 }}
              >
                Answer
              </Typography>
            )}
            {selectedOption !== "userOnlyQ" && (
              <TextField
                value={golden_response.answer}
                maxRows={4}
                multiline
                fullWidth
                placeholder="Enter Answer here..."
                onChange={(event) => handleChange_answer(event)}
                sx={inputStyles.textField}
              />
            )}
            {golden_response_validation && (
              <Typography
                variant="caption"
                sx={{ color: theme.state.error.primary, mb: 1 }}
              >
                Question and answer should not be empty text!
              </Typography>
            )}
            <Box sx={{ gap: 2, display: "flex" }}>
              <Button
                onClick={handleAddResponse}
                sx={{ ...primaryButtonStyles }}
              >
                Add {selectedOption === "userOnlyQ" ? "Question" : "Response"}
              </Button>
              <Tooltip title="Upload CSV of Golden Responses">
                <IconButton sx={iconButtonActive} component="label">
                  <FolderOutlined />
                  <input
                    type="file"
                    accept=".csv"
                    hidden
                    onChange={handleUploadCsv}
                  />
                </IconButton>
              </Tooltip>
            </Box>
          </Paper>

          {golden_responses_list?.length > 0 && (
            <Paper
              sx={{ ...goldenResponsesSectionStyles, flexDirection: "column" }}
            >
              {golden_responses_list?.map((response, index) => (
                <Box
                  sx={{
                    my: 1,
                    border: `1px solid ${theme.border.light}`,
                    borderRadius: theme.borderRadius.sm,
                    px: 2,
                    py: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    flexDirection: "row",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      key={`${index}_q`}
                      sx={{ fontSize: theme.typography.fontSize.xs }}
                    >
                      <strong>Question: </strong> {response?.question}
                    </Typography>
                    {selectedOption === "userQna" && (
                      <Typography
                        key={`${index}_a`}
                        sx={{ fontSize: theme.typography.fontSize.xs }}
                      >
                        <strong>Answer: </strong>
                        {response.answer}
                      </Typography>
                    )}
                  </Box>
                  <IconButton
                    sx={deleteIconStyles}
                    onClick={() => handleDeleteResponse(index)}
                  >
                    <DeleteOutline />
                  </IconButton>
                </Box>
              ))}
            </Paper>
          )}
        </DialogContent>
      </Dialog>

      {/* Confirmation Dialog */}
      <Dialog
        open={openDialog}
        onClose={() => handleDialogClose(false)}
        PaperProps={{ sx: { ...dialogStyles.dialogRoot } }}
      >
        <DialogTitle sx={dialogStyles.dialogTitle}>
          Warning: Change QnA Option
        </DialogTitle>
        <DialogContent sx={{ ...dialogStyles.dialogContent, mt: 2 }}>
          <DialogContentText sx={dialogStyles.dialogContentText}>
            Changing the QnA option will delete your previously uploaded golden
            responses. Do you want to continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={dialogStyles.dialogActions}>
          <Button
            onClick={() => handleDialogClose(false)}
            sx={textButtonStyles}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleDialogClose(true)}
            sx={primaryButtonStyles}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default GoldenResponseNode;
